var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9141 36.9571C17.9141 37.1445 18.0203 37.2381 18.1973 37.2381H27.6024C26.3641 35.9115 25.6422 33.6286 25.6422 30.7415C25.6422 27.867 26.3641 25.5944 27.5773 24.2803H18.1973C18.0203 24.2803 17.9141 24.3739 17.9141 24.5613V36.9571ZM27.2348 30.7415C27.2348 34.5052 28.532 36.9531 30.4476 36.9531C32.4304 36.9531 33.7859 34.5052 33.7859 30.7415C33.7859 26.9778 32.4304 24.5447 30.4476 24.5447C28.532 24.5447 27.2348 26.9778 27.2348 30.7415ZM33.3703 37.2381H42.7981C42.9752 37.2381 43.0814 37.1445 43.0814 36.9571V24.5613C43.0814 24.3739 42.9752 24.2803 42.7981 24.2803H33.3829C34.6336 25.5944 35.3659 27.867 35.3659 30.7415C35.3659 33.6286 34.6211 35.9115 33.3703 37.2381Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9258 40.1504C13.9258 40.7983 14.3569 41.2295 15.0048 41.2295H45.9999C46.6477 41.2295 47.0686 40.7983 47.0686 40.1504V21.3559C47.0686 20.7102 46.6477 20.2871 45.9999 20.2871H15.0048C14.3569 20.2871 13.9258 20.7102 13.9258 21.3559V40.1504ZM16.5331 37.9172V23.5993C16.5331 23.131 16.7903 22.8944 17.2209 22.8944H43.7734C44.2144 22.8944 44.4613 23.131 44.4613 23.5993V37.9172C44.4613 38.3753 44.2144 38.6221 43.7734 38.6221H17.2209C16.7903 38.6221 16.5331 38.3753 16.5331 37.9172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.469e8c5d6f6cb4601dbc51961c3e6bf7.svg";
export { ForwardRef as ReactComponent };